import React from "react";

interface ReceiptTextIconProps {
  style?: React.CSSProperties;
  title?: string;
}

/**
 * Receipt outline used by the Fee Manager application card.
 *
 * Interstate ships no receipt glyph, so this is a local component. Unlike the Interstate icons in
 * CardIcon's ICON_MAP this artwork is stroke-based (`fill="none"`), which is why `receipt_long` is
 * registered in CardIcon's STROKE_ICON_KEYS — without that, the wrapper's
 * `& svg path { fill: white !important }` rule would fill the outline into a solid white blob.
 *
 * Sized in `em` (not px) to match Interstate's font-size-driven icons, so CardIcon's `iconSize`
 * still applies. `stroke="currentColor"` lets the wrapper's `color: white` tint the strokes.
 */
export const ReceiptTextIcon: React.FC<ReceiptTextIconProps> = ({
  style,
  title
}) => (
  <svg
    aria-hidden={title ? undefined : true}
    fill="none"
    height="1em"
    style={style}
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M8 7h8m-8 4h8m-8 4h4m8 6V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16l2.5-2 3 2 2.5-2 2.5 2 3-2 2.5 2z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
